import { SearchTerm } from './SearchTerm';

const DiscoverySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "productName",
        translationKey: "name"
    },
    {
        heading: "Fixed Address",
        accessor: "fixedAddress",
        searchOnName: "fixedAddress",
        translationKey: "fixedAddress"
    },
    {
        heading: "IP Address",
        accessor: "ipAddress",
        searchOnName: "ipAddress",
        translationKey: "ipAddress"
    }
]

export default DiscoverySearch;
